const __RELATIVE_SOURCE_FILE__ /* __INJECTED__ */ = 'libs/common_web/src/actions/patAppointmentsActions.ts';
import { KISAPI as API } from '../middleware/kisapi';
import { KisApiAction, kisapiActionTypes } from '../defs/actionTypes';
import {
    apiLoad1Appointment,
    apiLoadStructuredAppointmentsOfPat,
} from '@cistec/common_web/actions/kisapi/appointments';

export const actionTypes = {
    loadAppointmentRecord: kisapiActionTypes('COMMON_LOAD_APPOINTMENT_RECORD'),
    loadStructuredAppointmentsForPatient: kisapiActionTypes('LOAD_STRUCTURED_APPOINTMENTS_FOR_PATIENT'),
    forgetStructuredAppointmentsForPatient: 'FORGET_STRUCTURED_APPOINTMENTS_FOR_PATIENT',
};

/**
 * Loads a single appointment (KisTermin)
 */
export function loadAppointmentRecord(
    termnr: string | null,
    disallowArrays: boolean = true,
    resolveRefs: boolean = false
) {
    return {
        type: actionTypes.loadAppointmentRecord.combined,
        [API]: apiLoad1Appointment(termnr, disallowArrays, resolveRefs),
        meta: { termnr, disallowArrays, resolveRefs },
    };
}

export type LoadAppointmentRecordAction = KisApiAction<typeof loadAppointmentRecord>;

/**
 * Action to load the appointments in a given time window
 */
export function actionLoadStructuredAppointmentsForPatient(
    patnr: string,
    mindat: string,
    maxdat: string,
    disallowArrays: boolean = false
) {
    return <const>{
        type: actionTypes.loadStructuredAppointmentsForPatient.combined,
        [API]: apiLoadStructuredAppointmentsOfPat(patnr, mindat, maxdat, disallowArrays),
        meta: {
            patnr,
            mindat,
            maxdat,
            showDlgWhenResultHasMoreRows: true,
        },
    };
}

export type LoadStructuredAppointmentsForPatientAction = KisApiAction<
    typeof actionLoadStructuredAppointmentsForPatient
>;

/**
 * Drops all the appointment records of a given patient.
 */
export function forgetStructuredAppointmentsForPatient() {
    return <const>{
        type: actionTypes.forgetStructuredAppointmentsForPatient,
    };
}

export type ForgetStructuredAppointmentsForPatientAction = ReturnType<typeof forgetStructuredAppointmentsForPatient>;
